import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { FiArrowRight, FiSearch } from "react-icons/fi";
import { booksResultsPath } from "pages2/Books/booksQueryParams";
import useGetLandingPageStats from "api/Statistics/useGetLandingPageStats";
import HeroShowcase from "./HeroShowcase";
import { formatLibraryCount } from "./libraryStats";

const HomeHero = () => {
	const [search, setSearch] = useState("");
	const history = useHistory();
	const { data: stats } = useGetLandingPageStats();
	const books = formatLibraryCount(stats?.total_active_books);
	const users = formatLibraryCount(stats?.total_registered_users);
	const findBooks = (event) => {
		event.preventDefault();
		history.push(booksResultsPath({ search_term: search.trim() }));
	};

	return (
		<section className="home-hero" aria-labelledby="home-heading">
			<div className="home-hero-brand-art" aria-hidden="true"><svg viewBox="0 0 640 640" focusable="false"><circle className="home-brand-planet" cx="340" cy="320" r="246" /><ellipse className="home-brand-orbit" cx="320" cy="340" rx="310" ry="112" transform="rotate(-26 320 340)" /><circle className="home-brand-satellite" cx="544" cy="108" r="14" /></svg></div>
			<div className="home-wrap">
				<div className="home-hero-grid">
					<div className="home-hero-copy">
						<h1 id="home-heading"><span className="home-brand-name">Akello Library.</span><br /><em>A world to discover.</em></h1>
						<p className="home-hero-description">School books, big ideas, and stories you’ll love. Find your next read and take it with you in the Akello app.</p>
						<div className="home-actions home-hero-actions">
							<Link to="/books" className="home-button home-button-primary">Browse books <FiArrowRight aria-hidden="true" /></Link>
							{(books || users) && <dl className="home-hero-stats" aria-label="Akello Library community">
								{books && <div><dt>Books</dt><dd>{books}</dd></div>}
								{users && <div><dt>Registered users</dt><dd>{users}</dd></div>}
							</dl>}
						</div>
						<form className="home-search" role="search" aria-label="Library catalogue" onSubmit={findBooks}>
							<label className="home-sr-only" htmlFor="home-book-search">Search the library</label>
							<div className="home-search-field"><FiSearch aria-hidden="true" />
								<input id="home-book-search" type="search" placeholder="Title, author, or keyword" value={search} onChange={(event) => setSearch(event.target.value)} />
								<button type="submit" aria-label="Search books">Search</button>
							</div>
						</form>
					</div>
					<HeroShowcase />
				</div>
			</div>
		</section>
	);
};
export default HomeHero;
